import type { ReactElement, ReactNode } from 'react';

/** The Settings page sections, in the order the owner reads them. */
export const SETTINGS_SECTIONS = [
  { id: 'settings-account', label: 'Account' },
  { id: 'settings-ai', label: 'AI & Workers' },
  { id: 'settings-computers', label: 'Computers' },
  { id: 'settings-projects', label: 'Projects' },
  { id: 'settings-rules', label: 'Rules' },
] as const;

/** Jump links for the Settings groups. Layout only: nothing here changes a control. */
export function SettingsSectionNav(): ReactElement {
  return (
    <nav className="settings-nav" aria-label="Settings sections">
      {SETTINGS_SECTIONS.map((section) => (
        <a key={section.id} href={`#${section.id}`}>{section.label}</a>
      ))}
    </nav>
  );
}

export function SettingsGroup({ id, label, children }: {
  id: string;
  label: string;
  children: ReactNode;
}): ReactElement {
  const headingId = `${id}-heading`;
  return (
    <section id={id} className="settings-group" aria-labelledby={headingId}>
      <h2 id={headingId}>{label}</h2>
      {children}
    </section>
  );
}
